<style lang="scss" scoped>
.active-art {
  @media screen and (max-width: 768px) {
    height: 88%;

    &.active-category {
      height: 60%;
    }
  }

  .top-control {
    height: auto;
  }
}
img, .embed {
  // height: 65vh;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  // min-height: 100%;
  // min-width: 100%;
  transform: translate(-50%, -50%);


  @media screen and (max-width: 768px) {
    // max-height: 370px !important;
    &.sidebar-open {
      max-height: 80%;
    }
  }
}
// iframe {
//   width: 300px !important;
//   height: 200px !important;
// }
// .embed { 
//   position: relative;
//   padding-bottom: 56.25%; 
//   padding-top: 30px; 
//   height: 0; 
//   overflow: hidden; 
//  }

// .embed iframe, .embed object, .embed embed {
//    position: absolute; 
//    top: 0; 
//    left: 0;
//    width: 100%;
//    height: 100%;
//   }
.image-wrapper {
  position: relative;
  width: 100%;

  // &.info-open {
  //   img {
  //     max-height: 30vh !important;
  //     top: 35%;
  //   }
  // }
}
.arrow {
  align-items: center;
  // background-color: lightgray;
  display: flex;
  height: 85vh;
  padding: 6px;
  &:first-child {
    justify-content: flex-end;
  }
  justify-content: flex-start;
  
  i {
    color: #fff;
    font-size: 2rem;
  }

  @media screen and (max-width: 768px) {
    height: auto;
    width: 20% !important;

    i {
      font-size: 1.2rem;
    }
    &:first-child {
      justify-content: flex-end;
    }
    justify-content: flex-start;
  }
  
}
.active-title {
  margin: 10px 0;
  @media screen and (max-width: 768px) {
    display: none;
  }
}
.white-action {
  color: #fff;
  cursor: pointer;
}
.white-text {
  color: #fff;
}
.active-description {
  color: #cccccc !important;
  font-size: 14px;
  line-height: 1em;
  i { 
    display: none; 
  }
  @media screen and (max-width: 768px) {
    background-color: #fff;
    border: 1px solid #000;
    color: #000 !important;
    display: none;
    font-size: 12px;
    font-size: 12px;
    margin: auto;
    padding: 1px;
    width: 85%;
    &.mobile-show {
      display: block;
    }

    i {
      display: block; 
      float: right;
      padding: 2px;
    }
  }
  .mobile-title {
    display: none;
    font-size: 14px;
    margin: 1px 10px 0px;

    @media screen and (max-width: 768px) {
      display: block; 
    }
  }
}
.toggle-image-info {
  color: #fff;
  display: none;
  position: absolute;
  top: 92%;
  left: 49%;
  z-index: 1;

  @media screen and (max-width: 768px) {
    display: block;
    &.active-category {
      top: 105%;
      &.full {
        top: 118%;
      }
    }
   }
}
.icon {
  cursor: pointer;
  font-size: 28px;
}
.tag {
  margin: 3px;
  cursor: pointer;

  @media screen and (max-width: 768px) {
    font-size: .5rem;
    margin: 2px;
  }
}
.clear-active-image {
  position: fixed;
  top: 9px;
  z-index: 5;
  i {
    font-size: 1.5em;
  }
}
.active-controls {
  bottom: 10px;
  padding: 10px;
  margin-bottom: 20px;
  position: absolute;
  width: 100%;

  @media screen and (max-width: 768px) {
    bottom: 17px;
    margin-bottom: 0px;
  }
}
@media (max-height: 700px) {
  .image-wrapper {
    // height: 10vh;
    img {
      max-height: 45vh !important;
      &.active-category {
        max-height: 40vh !important;
      }
    }
  }
}
.active-tags {
  @media (max-width: 768px) {
    display: none;
    &.mobile-show {
      display: block;
      margin-bottom: 8px;
    }
  }
}
</style>

<template>
  <div
    class="active-art"
    :class="{'active-category': activeCategory}"
  >
    <!-- :style="{ 'min-height': settings.activeImageHeight }" -->
    <div class="frow centered-column top-control">
      <span
        v-if="!zen"
        class="white-action clear-active-image"
        @click="$emit('close')"
      >
        <i
          class="ion ion-md-grid"
        />
      </span>
    </div>
    <div
      v-if="activeArt.image"
      class="frow nowrap height-100"
    >
      <div class="arrow col-sm-2-12">
        <i
          class="icon ion-ios-arrow-back"
          @click="$emit('changeArt', 'previous')"
        />
      </div>
      <div 
        class="image-wrapper col-sm-8-12"
        :class="{'info-open': showImageInfo}"
      >
        <a
          v-if="activeArt.externalLink"
          :href="activeArt.externalLink"
          target="_blank"
        >
          <img
            :src="imageUrl"
            :style="{ 'max-height': settings.activeImageHeight }"
            :class="{'active-category': activeCategory, 'sidebar-open': sideBarOpen}"
            :alt="activeArt.altTag ? activeArt.altTag : activeArt.title"
          >
        </a>
        <Embed
          v-else-if="activeArt.embed"
          :key="activeArt.id"
          :video-id="activeArt.embed"
          class="embed width-100"
        />
        <img
          v-else
          :src="imageUrl"
          :style="{ 'max-height': settings.activeImageHeight }"
          :class="{'active-category': activeCategory, 'sidebar-open': sideBarOpen}"
          :alt="activeArt.altTag ? activeArt.altTag : activeArt.title"
        >
        <span 
          v-if="!zen && !showImageInfo"
          class="toggle-image-info"
          :class="{'active-category': activeCategory, 'full': !sideBarOpen }"
        >
          <i
            class="ion ion-md-information-circle-outline"
            @click="showImageInfo = true"
          />
        </span>
      </div>
      <div class="arrow col-sm-2-12">
        <i
          class="icon ion-ios-arrow-forward"
          @click="$emit('changeArt', 'next')"
        />
      </div>
    </div>
    <div
      class="frow centered-column"
    >
      <div
        v-if="!zen"
        class="active-controls"
      >
        <div
          :class="{'mobile-show': showImageInfo}"
          class="active-description"
        >
          <i
            class="ion ion-md-close-circle-outline"
            @click="showImageInfo = false"
          />
          <strong class="mobile-title">
            {{ activeArt.title }}
          </strong>
          <span v-html="activeArt.description" />
        </div>
        <div
          class="frow"
        >
          <strong class="white-text active-title">
            {{ activeArt.title }}
          </strong>
        </div>
        <div 
          v-if="activeArt.tags && activeArt.tags.length > 0"
          class="active-tags"
          :class="{'mobile-show': showImageInfo}"
        >
          <span
            v-for="tag in activeArt.tags"
            :key="tag"
            class="tag"
            @click="$emit('tagClicked', tag)"
            v-text="tag"
          />
        </div>
        <div v-else>
          <span>&nbsp;</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Embed from './Embed.vue';
export default {
  name: 'ActiveStory',
  components: {
    Embed,
  },
  props: {
    activeArt: {
      type: Object,
      default: () => {},
    },
    settings: {
      type: Object,
      default: () => {},
    },
    activeCategory: {
      type: String,
      default: null,
    },
    sideBarOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showImageInfo: false,
    };
  },
  computed: {
    ...mapState({
      zen: (state) => state.zen,
    }),
    imageUrl() {
      if (process.env.NODE_ENV === 'development') {
        // return `${this.$API}/${this.activeArt.image.url}`;
      }
      return this.activeArt.image.url;
    },
  },
};
</script>